import Vue from "vue";
import App from "./App.vue";
import router from "./router/client";
import store from "./store";
import vuetify from "@/plugins/vuetify";

require("./assets/main.scss");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
